import { toNote } from '@/lib/link'
import * as kinds from '@nostr/tools/kinds'
import { cn } from '@/lib/utils'
import { Event } from '@nostr/tools/wasm'

function getPreviewText(event: Event) {
  switch (event.kind) {
    case kinds.RepositoryAnnouncement: {
      let repoId: string | undefined
      let name: string | undefined

      for (const [tagName, ...values] of event.tags) {
        if (tagName === 'd' && !repoId) repoId = values[0]
        if (tagName === 'name' && !name) name = values[0]
      }

      return `[Repository] ${name || repoId || ''}`.trim()
    }
    case kinds.RepositoryState: {
      let repoId: string | undefined
      let head: string | undefined

      for (const [tagName, ...values] of event.tags) {
        if (tagName === 'd' && !repoId) repoId = values[0]
        if (tagName === 'HEAD' && !head) head = values[0]
      }

      return `[Repository state] ${repoId || head || ''}`.trim()
    }
    case kinds.Patch: {
      let subject: string | undefined

      for (const [tagName, ...values] of event.tags) {
        if (tagName === 'subject' && !subject) subject = values[0]
      }

      return `[Patch] ${subject || event.content || ''}`.trim()
    }
    case kinds.GitPullRequest: {
      let subject: string | undefined

      for (const [tagName, ...values] of event.tags) {
        if (tagName === 'subject' && !subject) subject = values[0]
      }

      return `[Pull request] ${subject || event.content || ''}`.trim()
    }
    case kinds.GitPullRequestUpdate: {
      let commit: string | undefined

      for (const [tagName, ...values] of event.tags) {
        if (tagName === 'c' && !commit) commit = values[0]
      }

      return `[Pull request update] ${commit || ''}`.trim()
    }
    case kinds.Issue: {
      let subject: string | undefined

      for (const [tagName, ...values] of event.tags) {
        if (tagName === 'subject' && !subject) subject = values[0]
      }

      return `[Issue] ${subject || event.content || ''}`.trim()
    }
    case kinds.StatusOpen:
      return '[Open]'
    case kinds.StatusApplied:
      return '[Applied / resolved]'
    case kinds.StatusClosed:
      return '[Closed]'
    case kinds.StatusDraft:
      return '[Draft]'
    case kinds.UserGraspList:
      return '[User grasp list]'
    default:
      return ''
  }
}

export default function GitEventPreview({
  event,
  className
}: {
  event: Event
  className?: string
}) {
  return (
    <div className={cn('pointer-events-none truncate', className)}>
      <a href={toNote(event)} onClick={(e) => e.preventDefault()}>
        {getPreviewText(event)}
      </a>
    </div>
  )
}
